export default (/^[^\s@]{2,}@[^\s@]{2,}\.[^\s@]{2,}$/);
